import { Box } from "@mui/material";

import { checkForUnexpectedProps } from "services/utility/misc";

export function CardGrid(props) {
  const { gridColumn, children, rowGap = 1, ...unexpected } = props;
  checkForUnexpectedProps("CardGrid", unexpected);

  return (
    <Box
      sx={{
        display: "grid",
        rowGap,
        gridColumn: gridColumn,
        gridAutoRows: "min-content",
      }}
    >
      {children}
    </Box>
  );
}
